import { createContext } from 'react'

export const VoterOnboardingContext = createContext()
